import 'web-animations-js';
import Misc from './misc';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import './header-search';

// Animatin helpers
const headerMenuAnimation = {
  
  // element, height, duration, delay, onAnimationFinish, onAnimationBefore
  slideUp: function(options) {

    const delay = options.hasOwnProperty('delay') ? options.delay : 0;
    const duration = options.hasOwnProperty('duration') ? options.duration : 200;
    const slideDownAnimation = options.element.animate({
      height: [`${options.height}px`, 0],
    opacity: [1, 0],
    }, {
      delay: delay,
      duration: duration, 
      fill: 'forwards',
    });

    typeof options.onAnimationBefore === 'function' && options.onAnimationBefore(slideDownAnimation);

    slideDownAnimation.onfinish = () => {
      options.element.style.removeProperty('height');
      options.element.style.removeProperty('opacity');
      slideDownAnimation.cancel();
      typeof options.onAnimationFinish === 'function' && options.onAnimationFinish(slideDownAnimation);
    }
  },

  // element, height, duration, delay, onAnimationFinish, onAnimationBefore
  slideDown: function(options) {

    const delay = options.hasOwnProperty('delay') ? options.delay : 0;
    const duration = options.hasOwnProperty('duration') ? options.duration : 200;
    const slideDownAnimation = options.element.animate({
      height: [0, `${options.height}px`],
      opacity: [0, 1],
    }, {
      delay: delay,
      duration: duration, 
      fill: 'forwards',
    });

    typeof options.onAnimationBefore === 'function' && options.onAnimationBefore(slideDownAnimation);

    slideDownAnimation.onfinish = () => {
      options.element.style.setProperty('height', `${options.height}px`);
      options.element.style.setProperty('opacity', 1);
      slideDownAnimation.cancel();
      typeof options.onAnimationFinish === 'function' && options.onAnimationFinish(slideDownAnimation);
    }
  },

  // element, height, onAnimationFinish, onAnimationBefore
  fadeOut: function(options) {
    
    const delay = options.hasOwnProperty('delay') ? options.delay : 0;
    const duration = options.hasOwnProperty('duration') ? options.duration : 200;
    const fadeOutAnimation = options.element.animate({
      opacity: [1, 0],
    }, {
      duration: duration,
      delay: delay,
      fill: 'forwards',
    });

    typeof options.onAnimationBefore === 'function' && options.onAnimationBefore(fadeOutAnimation);

    fadeOutAnimation.onfinish = () => {
      options.element.style.removeProperty('height');
      options.element.style.removeProperty('opacity');
      options.element.classList.remove('active');
      fadeOutAnimation.cancel();

      typeof options.onAnimationFinish === 'function' && options.onAnimationFinish(fadeOutAnimation);
    }; 

  }
};

class headerMenu { 
  constructor() {

    this.mobileMenuLayout = Misc.getMediaQueries()['mobilemenu-layout'];
    this.triggerMenu = document.querySelector('.site-header--trigger a');
    this.headerWrapper = document.querySelector('.site-header')
    this.menuWrapper = document.querySelector('.site-header--menu');

    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleOnResize = this.handleOnResize.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleSubMenu = this.handleSubMenu.bind(this);


    // Init if mobilemenurea
    if (Misc.getViewport().width < this.mobileMenuLayout) {
      window.bodyLayout = 'mobilemenu-layout';
      this.triggerMenu.addEventListener('click', this.toggleMenu);
    }

    [].slice.call(document.querySelectorAll('.menu-item-has-children')).forEach(item => {
      item.firstElementChild.addEventListener('click', this.handleSubMenu)
    })

    // Handle on Resize
    window.addEventListener('resize', this.handleOnResize);
    window.addEventListener('scroll', this.handleOnScroll);

  }

  toggleMenu(event) {
    event.preventDefault();
    const menuNavHeight = this.getMenuNavHeight();

    if (!this.triggerMenu.classList.contains('active')) {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  }

  getMenuNavHeight() {
    let menu = this.menuWrapper.querySelector('.site-header--nav').getBoundingClientRect().height;
    let tools = this.menuWrapper.querySelector('.site-header--tools').getBoundingClientRect().height;
    return parseInt(menu + tools + 1);
  }

  getMenuWrapperHeight() {
    return parseInt(this.headerWrapper.querySelector('.site-header--logo').getBoundingClientRect().height);
  }

  openMenu() {
    let menuNavHeight = this.getMenuNavHeight();
    const menuWrapperHeight = this.getMenuWrapperHeight();
    const viewportHeight = Misc.getViewport().height;
    
    this.headerWrapper.style.height = `${viewportHeight}px`;
    this.triggerMenu.classList.add('active');

    if (document.querySelector('#wpadminbar')) {
      menuNavHeight += document.querySelector('#wpadminbar').getBoundingClientRect().height;
    }
    
    const headerAnimation = this.headerWrapper.animate({
      backgroundColor: ['transparent', '#FFF']
    }, {
      duration: 200, 
      fill: 'forwards',
    });


    headerMenuAnimation.slideDown({
      element:this.menuWrapper,
      height: menuNavHeight, 
      onAnimationFinish: () => {
        disableBodyScroll(this.headerWrapper)
      }
    });

    headerAnimation.onfinish = () => {
      this.headerWrapper.style.setProperty('background-color', '#FFF');
      headerAnimation.cancel();
    }

  }

  closeMenu() {
    const menuNavHeight = this.getMenuNavHeight();
    const menuWrapperHeight = this.getMenuWrapperHeight();
    const viewportHeight = Misc.getViewport().height;
    
    headerMenuAnimation.fadeOut({
      element:this.menuWrapper,
      onAnimationFinish: () => {
        this.headerWrapper.style.removeProperty('height');
        this.triggerMenu.classList.remove('active');
        enableBodyScroll(this.headerWrapper);
      }
    })
    
    const headerAnimation = this.headerWrapper.animate({
      background: ['#FFF', 'transparent']
    }, {
      duration: 200, 
      fill: 'forwards',
    });

    headerAnimation.onfinish = () => {
      this.headerWrapper.style.removeProperty('background-color');
      this.headerWrapper.style.removeProperty('opacity');
      headerAnimation.cancel();
    }  
  }

  handleOnResize() {
    if (Misc.getViewport().width > this.mobileMenuLayout && window.bodyLayout === 'nondesktop-layout') {
      window.bodyLayout = null;
      this.triggerMenu.removeEventListener('click', this.toggleMenu);
      this.triggerMenu.classList.remove('active');
      this.headerWrapper.removeAttribute('style');
      this.menuWrapper.removeAttribute('style');
      clearAllBodyScrollLocks();
    }

    if (Misc.getViewport().width < this.mobileMenuLayout && window.bodyLayout !== 'nondesktop-layout') {
      window.bodyLayout = 'nondesktop-layout';
      this.triggerMenu.addEventListener('click', this.toggleMenu);
    }
  }

  handleOnScroll(event) {
    const scrollTop = document.documentElement.scrollTop;

    if (!this.headerWrapper.classList.contains('header-wrapper--absolute')) {
      return false;
    }
    
    if (Misc.getViewport().width < this.mobileMenuLayout) {
      return this.headerWrapper.classList.remove('header-wrapper--fixed')
    }

    if (scrollTop > 0) {
      this.headerWrapper.classList.add('header-wrapper--fixed')
    } else {
      this.headerWrapper.classList.remove('header-wrapper--fixed')
    }
  }

  handleSubMenu(event) {
    event.preventDefault();
    console.log('event.currentTarget');
    if (Misc.getViewport().width > this.mobileMenuLayout) {
      return false;
    }
      
    event.preventDefault();
    const subMenu = event.currentTarget.parentElement.querySelector('.sub-menu');
    const subMenuHeight = this.getSubMenuHeight(subMenu);
    if (!event.currentTarget.classList.contains('active') ) {
      this.openSubMenu(event, subMenu, subMenuHeight);
      // event.currentTarget.classList.add('active');
      // subMenu.style.setProperty('display', 'block');
      // this.menuWrapper.style.height = `${this.menuWrapper.getBoundingClientRect().height + subMenu.getBoundingClientRect().height}px`;
    } else {
      this.closeSubMenu(event, subMenu, subMenuHeight);
      // this.menuWrapper.style.height = `${this.menuWrapper.getBoundingClientRect().height - subMenu.getBoundingClientRect().height}px`;
      // event.currentTarget.classList.remove('active');
      // subMenu.style.removeProperty('display');
    }

  }

  openSubMenu(event, subMenu, subMenuHeight) {
    headerMenuAnimation.slideDown({
      element: subMenu,
      height: subMenuHeight,
      onAnimationBefore: () => {
        this.menuWrapper.style.height = `${this.menuWrapper.getBoundingClientRect().height + subMenuHeight}px`;
        event.currentTarget.classList.add('active');
      }
    });
  }

  closeSubMenu(event, subMenu, subMenuHeight) {
    headerMenuAnimation.slideUp({
      element: subMenu,
      height: subMenuHeight,
      onAnimationBefore: () => {
        event.currentTarget.classList.remove('active');
      },
      onAnimationFinish: () => {
        this.menuWrapper.style.height = `${this.menuWrapper.getBoundingClientRect().height - subMenuHeight}px`;
      }
    });
  }

  getSubMenuHeight(subMenu) {
    let totalHeight = 0;
    [].slice.call(subMenu.querySelectorAll('li')).forEach( item => {
      totalHeight += item.getBoundingClientRect().height;
    })
    return totalHeight;
  }

}

// window.onload = function() {
new headerMenu();
// };


// set navigation scroll style
function scrollNavigation() {
  const navigation = document.querySelector(".site-header");
  const scrollHeight = 125;
  let scrollpos = window.scrollY;
  if (scrollpos >= scrollHeight) {
    navigation.classList.add("is-scrolling");
  } else {
    navigation.classList.remove("is-scrolling");
  }
}

window.addEventListener("scroll", scrollNavigation, false);